import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from "react-redux";
import {applyMiddleware, compose, createStore} from "redux";
import * as serviceWorker from './serviceWorker';
import {rootReducer} from "./Components/ducks";
import App from './App';
import './index.css';

const json_data_url = 'https://raw.githubusercontent.com/sfarmani/twrpg-info/master/items.json';
export let items;

// noinspection JSUnresolvedVariable
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    trace: true,
    maxAge: 100,
    autoPause: true
  })
  : compose;

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware())
);

fetch(json_data_url)
  .then(response => response.json())
  .then(json_data => items = json_data)
  .then(() =>
    ReactDOM.render(
      <Provider store={store}>
        <App/>
      </Provider>,
      document.getElementById('root'))
  );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
